import { Box } from '@mui/material';
import React from 'react';
import { ITkContractorAndNumberLineProps } from '../../../type/componentsType/TkContractorAndNumberLineProps';
import TkFakeTableLine from '../../atoms/TkFakeTableLine';
import './_style.scss';

/**
 * TkContractorAndNumberLineコンポーネントは、請負業者名と番号を表示するためのコンポーネントです。
 * 
 * @param {ITkContractorAndNumberLineProps} props - コンポーネントのプロパティ
 * @param {string} props.name - 請負業者名
 * @param {string} props.no - 番号
 * @returns {React.FC} TkContractorAndNumberLineコンポーネント
 */
const TkContractorAndNumberLine: React.FC<ITkContractorAndNumberLineProps> = (props) => {
  const { name, no} = props;

  return (
    <Box className='tkContractorAndNumberLine'>
      <TkFakeTableLine 
        type='text'
        title={name}
        text={no}
      />
    </Box>
  );
};

export default TkContractorAndNumberLine;
